import { LyfeTheme } from "@lyfegen-platform/react-common";
import { CssBaseline } from "@material-ui/core";
import ReactDOM from "react-dom";
import { RecoilRoot } from "recoil";
import ModalDialog, { IText } from "../../components/ModalDialog";

const userConfirmOpen = (text: IText, onContine: (prop?: any) => void) => {
	const container = document.createElement("div");

	container.setAttribute("custom-confirm-view", "");

	const handleContinue = (callbackState?: any) => {
		ReactDOM.unmountComponentAtNode(container);
		onContine(callbackState);
	};

	const handleDiscard = () => {
		ReactDOM.unmountComponentAtNode(container);
	};

	document.body.appendChild(container);

	ReactDOM.render(
		<RecoilRoot>
			<LyfeTheme app="platform-new">
				<CssBaseline />
				<ModalDialog isOpen={true} onContinueClick={handleContinue} onDiscardClick={handleDiscard} text={text} />
			</LyfeTheme>
		</RecoilRoot>,
		container
	);
};

export default userConfirmOpen;
